import { render } from "./View404.vue?vue&type=template&id=7fa1d652&scoped=true&ts=true"
import script from "./View404.vue?vue&type=script&lang=ts"
export * from "./View404.vue?vue&type=script&lang=ts"

import "./View404.vue?vue&type=style&index=0&id=7fa1d652&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa1d652"]])

export default __exports__